import { render } from "./TopCollections.vue?vue&type=template&id=49bf19d0&ts=true"
import script from "./TopCollections.vue?vue&type=script&lang=ts"
export * from "./TopCollections.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__